import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import { generate as generateTogglePanel } from '../toggle-panel/schema';
import type { IComponentProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();
  const panel1 = generateTogglePanel({
    'x-component-props': { tab: 'Panel 1', defaultVisible: true },
    'x-index': 0,
  });
  const panel2 = generateTogglePanel({
    'x-component-props': { tab: 'Panel 2', defaultVisible: true },
    'x-index': 1,
  });

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.TogglePanels,
    'x-component-props': {
      visible: true,
      direction: 'horizontal',
      height: 400,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    properties: {
      [panel1.name]: panel1,
      [panel2.name]: panel2,
    },
  };
};
